import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-data",
  "use": "icon-data-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-data\"><defs><style type=\"text/css\"></style></defs><path d=\"M614.877387 119.128191v473.290591L265.558483 924.739365A473.358858 473.358858 0 0 0 556.646192 1023.998635c257.705464 0 466.737022-203.365451 466.737022-454.312547 0-231.627719-178.175169-422.636961-408.505827-450.557897z\" p-id=\"4467\" /><path d=\"M148.140365 949.656582L502.988842 618.496527l-353.619683-332.457115C57.75572 368.846492 0.54852 487.083807 0.54852 618.496527c0 130.730057 56.661069 248.421241 147.455312 331.160055zM546.064908 564.566112V0.003413a642.318069 642.318069 0 0 0-433.286512 166.433357L546.064908 564.566112z\" p-id=\"4468\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/data.svg
// module id = RUrO
// module chunks = 112